// Generated by tools/build/i18n_bundle.py — do not edit by hand.
// Adopt the language a localized marketing page named in ?lang= on the link
// it sent this visitor here by. localStorage is per-origin, so the URL is the
// only thing that crosses. Precedence and the seed sentinel mirror
// site/js/head-init.js; the readers are i18n/bundles-loader.js and js/i18n.js.
(function () {
  var SHIPPED = ["en", "nl", "de", "es", "fr", "pt", "it", "hu", "ru", "pl", "id", "tr", "ca", "uk", "el", "cs", "sv", "nb", "ro", "fi", "th", "vi", "bg", "da", "ja", "ko", "zh"];
  var params;
  try {
    params = new URLSearchParams(location.search);
  } catch (e) {
    return;
  }
  var named = params.get("lang");
  if (!named) return;
  var lang = String(named).replace("_", "-").split("-")[0].toLowerCase();
  if (SHIPPED.indexOf(lang) === -1) return;
  // A deliberate in-app choice outranks the page someone arrived from.
  var adopt = true;
  try {
    var stored = localStorage.getItem("ghd_ui_lang");
    var seed = localStorage.getItem("ghd_ui_lang_seed");
    adopt = !stored || seed === null || stored === seed;
    if (adopt) {
      localStorage.setItem("ghd_ui_lang", lang);
      localStorage.setItem("ghd_ui_lang_seed", lang);
    }
  } catch (e) {
    // Storage blocked: nothing to defer to, and nothing to remember it in.
    // The global below is the whole handoff for this page load.
  }
  if (adopt) window.__GHD_ARRIVAL_LANG__ = lang;
  // Spend the parameter either way. It has been read, and a URL that keeps
  // pinning a language is one people copy to somebody who reads another.
  try {
    params.delete("lang");
    var rest = params.toString();
    history.replaceState(history.state, "", location.pathname + (rest ? "?" + rest : "") + location.hash);
  } catch (e) {}
})();
